import React from 'react';
import { PANELS, PANELS_TYPES } from 'app/containers/MainDashboard/consts.js';
import FilterField from 'app/containers/MainDashboard/components/FilterField.jsx';
import { filtersFields } from 'app/containers/MainDashboard/consts';
import SaveDashboardPanel from 'app/containers/MainDashboard/components/SaveDashboardPanel';
import { PANEL_COMPONENT_TYPES } from 'usage/containers/CustomDashboard/constants/customDashboardConstants';
import classnames from 'classnames';
import { GroupByItem, MtdCostBreakdownHeaderProps } from './types.ts';
import NavigateIcon from 'app/containers/MainDashboard/components/NavigateIcon';
import { getSearchParamsPanel } from 'app/containers/MainDashboard/utils';
import { useRootStore } from 'app/contexts/RootStoreContext';
import mainStyles from '../../mainDashboardCommon.module.scss';
import styles from './mtdCostBreakdown.module.scss';

const HeaderPanel: React.FC<MtdCostBreakdownHeaderProps> = ({
  groupByFirst,
  setGroupByFirst,
  groupBySecond,
  setGroupBySecond,
  options,
  hideSaveDashboard,
  navigateCueParams,
}) => {
  const { appStore } = useRootStore();
  const validGroupByFirst = groupByFirst.filter((item): item is GroupByItem => item !== undefined);
  const validGroupBySecond = groupBySecond.filter((item): item is GroupByItem => item !== undefined);
  const optionsGroup1 = options.map((o) => {
    return {
      ...o,
      isDisabled: o.value === groupBySecond?.[0]?.value,
    };
  });
  const optionsGroup2 = options.map((o) => {
    return {
      ...o,
      isDisabled: o.value === groupByFirst?.[0]?.value,
    };
  });
  return (
    <div className={classnames(mainStyles.headerRow)}>
      <div className={styles.headerWrapper}>
        <span className={mainStyles.header}>{PANELS[PANELS_TYPES.COST_BREAKDOWN].title}</span>
        <FilterField
          filterType={filtersFields.groupBy1}
          onSelectMultiButtonClick={() => {}}
          selectedOptions={groupByFirst}
          handleSelectionChange={(options) => setGroupByFirst([options])}
          options={optionsGroup1}
          height={335}
          width={215}
        />
        <FilterField
          filterType={filtersFields.groupBy2}
          onSelectMultiButtonClick={() => {}}
          selectedOptions={groupBySecond}
          handleSelectionChange={(options) => setGroupBySecond([options])}
          options={optionsGroup2}
          height={335}
          width={215}
        />
      </div>
      {!hideSaveDashboard && (
        <div className={styles.actionWrapper}>
          <NavigateIcon
            getSearchParams={() => getSearchParamsPanel(navigateCueParams, appStore.isPpApplied)}
            id={PANELS_TYPES.COST_BREAKDOWN}
            tooltipText="Open in Cost & Usage Explorer page"
          />
          <SaveDashboardPanel
            panelType={PANEL_COMPONENT_TYPES.COST_BREAKDOWN}
            groupBy={validGroupByFirst}
            granLevel="month"
            secondGroupBy={validGroupBySecond}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderPanel;
